// Atomを管理するキー
export enum AtomKeys {
  ACCT_STATE = "acctState",
  MODAL_CONFIRME_STATE = "modalConfirmState",
  NAVBAR_STATE = "navbarState",
  NOTICE_MESSAGE_STATE = "noticeMessageState",
}

// Selectorを管理するキー
export enum SelectorKeys {}
